import { render, staticRenderFns } from "./f-menu.vue?vue&type=template&id=83f4a81a&scoped=true"
import script from "./f-menu.vue?vue&type=script&lang=js"
export * from "./f-menu.vue?vue&type=script&lang=js"
import style0 from "./f-menu.vue?vue&type=style&index=0&id=83f4a81a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f4a81a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f4a81a')) {
      api.createRecord('83f4a81a', component.options)
    } else {
      api.reload('83f4a81a', component.options)
    }
    module.hot.accept("./f-menu.vue?vue&type=template&id=83f4a81a&scoped=true", function () {
      api.rerender('83f4a81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/svgs/f-menu.vue"
export default component.exports